import React, { useState, useEffect, useRef } from "react";
import { Button } from "reactstrap";

import "react-datepicker/dist/react-datepicker.css";
import { Modal } from "react-bootstrap";
import Swal, { swalError, confirmSwal } from "../../../swal";
import { sendData } from "../../../../helpers/auth";
import { getAcls } from "../../../../helpers/acls";
import { Aguarde, width } from "../../../../helpers/general";
import { uriList } from "../../../../helpers/config";
import { connect } from "react-redux";

// Adiciona função utilitária para ordenar por label
function sortByLabel(arr) {
    if (!arr) return [];
    return arr.slice().sort((a, b) => {
        if ((a.label || "") < (b.label || "")) return -1;
        if ((a.label || "") > (b.label || "")) return 1;
        return 0;
    });
}

// Função utilitária para normalizar strings (igual a do acls.js)
function normalizePermissao(str) {
    if (!str) return '';
    return str
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // remove acentos
        .replace(/[^a-zA-Z0-9]/g, '')   // remove caracteres especiais
        .toLowerCase();
}

const Form = ({ ...props }) => {
    const [usuario, setusuario] = useState(props.usuario);
    const [gravando, setGravando] = useState(false);
    // const [selectAll, setSelectAll] = useState(false); // REMOVIDO: não é mais necessário
    const [multSelect, setMultSelect] = useState(true);
    const [permissoes, setPermissoes] = useState(null);
    const [permissoesFiltradas, setPermissoesFiltradas] = useState(null);
    const [clickedTr, setClickedTr] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [carregando, setCarregando] = useState(true);

    // NOVO: filtro de marcadas
    const [showOnlyChecked, setShowOnlyChecked] = useState(false);

    // Para saber se houve alteração nas permissões (checked) desde o carregamento
    const [permissoesOriginais, setPermissoesOriginais] = useState([]);
    // Para focar o input ao limpar
    const searchInputRef = useRef(null);

    useEffect(() => {
        carregarPermissoes();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (permissoes) {
            let filtered = permissoes.filter(permissao =>
                (permissao.description || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
                (permissao.name || "").toLowerCase().includes(searchTerm.toLowerCase())
            );
            if (showOnlyChecked) {
                filtered = filtered.filter(p => p.checked);
            }
            setPermissoesFiltradas(sortByLabel(filtered));
            setCarregando(false);
        }
    }, [searchTerm, permissoes, showOnlyChecked]);

    async function carregarPermissoes() {
        setCarregando(true);
        // 1. Carrega todas as permissões possíveis do arquivo acls.js
        let todasPermissoes = getAcls();

        // 2. Busca as permissões já preenchidas para o usuário
        let uri = uriList("buscaraclusuario");
        try {
            const res = await sendData({ uri, content: { ...usuario }, method: "POST" });
            if (res.status === 200) {
                const permissoesUsuario = Array.isArray(res.data) ? res.data : [];
                // Cria um Set com as permissões já preenchidas, normalizando name e action
                const permissoesPreenchidas = new Set();
                permissoesUsuario.forEach(p => {
                    if (p.name) permissoesPreenchidas.add(normalizePermissao(p.name));
                    if (p.action) permissoesPreenchidas.add(normalizePermissao(p.action));
                });
                // Marca como checked as permissões que o usuário já possui (comparando normalizado)
                const permissoesComChecked = todasPermissoes.map(p => {
                    const nameNorm = normalizePermissao(p.name);
                    const actionNorm = normalizePermissao(p.action);
                    const checked = permissoesPreenchidas.has(nameNorm) || permissoesPreenchidas.has(actionNorm);
                    return {
                        ...p,
                        checked
                    };
                });
                setPermissoes(permissoesComChecked);
                setPermissoesFiltradas(sortByLabel(permissoesComChecked));
                // Salva o estado original das permissões marcadas para comparação posterior
                setPermissoesOriginais(permissoesComChecked.map(p => !!p.checked));
            } else {
                swalError({ title: "Erro ao buscar permissões do usuário", text: res._status });
                // Mesmo em erro, mostra todas as permissões desmarcadas
                const permissoesComChecked = todasPermissoes.map(p => ({
                    ...p,
                    checked: false
                }));
                setPermissoes(permissoesComChecked);
                setPermissoesFiltradas(sortByLabel(permissoesComChecked));
                setPermissoesOriginais(permissoesComChecked.map(p => false));
            }
        } catch (e) {
            console.log("usuariosacl.carregarPermissoes(error)", e);
            swalError({ title: "Erro ao buscar permissões do usuário", text: e?.message || "Erro desconhecido" });
            // Em caso de erro, mostra todas as permissões desmarcadas
            const permissoesComChecked = todasPermissoes.map(p => ({
                ...p,
                checked: false
            }));
            setPermissoes(permissoesComChecked);
            setPermissoesFiltradas(sortByLabel(permissoesComChecked));
            setPermissoesOriginais(permissoesComChecked.map(p => false));
        }
        setCarregando(false);
    }

    async function handlePost() {
        async function callback(e) {
            if (!e)
                return;
            let uri = uriList("gravaraclusuario");
            let _permissoes = permissoes.filter((permissao) => permissao.checked);
            let content = { usuario, permissoes: _permissoes };
            setGravando(true);
            return await sendData({ uri, content, method: "POST" })
                .then((res) => {
                    if (res._status == 200) {
                        // Atualiza o snapshot das permissões originais após gravar
                        setPermissoesOriginais(permissoes.map(p => !!p.checked));
                        handleClose(true); // true = gravou
                    } else {
                        swalError({ title: "Erro ao gravar permissões do usuário", text: res.message });
                    }
                    setGravando(false);
                })
                .catch((e) => {
                    console.log("usuariosacl.handlePost(error)");
                    console.log(e)
                    setGravando(false);
                });
        }

        confirmSwal({ title: "Confirma a gravação das permissões?", text: "", callback });
    }

    // Função para verificar se houve alteração nas permissões marcadas
    function houveAlteracaoPermissoes() {
        if (!permissoes || permissoes.length === 0) return false;
        if (!permissoesOriginais || permissoesOriginais.length !== permissoes.length) return true;
        for (let i = 0; i < permissoes.length; i++) {
            if (!!permissoes[i].checked !== !!permissoesOriginais[i]) {
                return true;
            }
        }
        return false;
    }

    // handleClose agora verifica se há alterações não gravadas
    function handleClose(gravou = false) {
        // Se já gravou, pode fechar direto
        if (gravou) {
            if (props.onCloseEv)
                props.onCloseEv();
            return;
        }
        // Se não houve alteração, pode fechar direto
        if (!houveAlteracaoPermissoes()) {
            if (props.onCloseEv)
                props.onCloseEv();
            return;
        }
        // Se houve alteração, pergunta ao usuário
        confirmSwal({
            title: "Permissões não salvas",
            text: "Existem permissões marcadas/desmarcadas que não foram gravadas. Deseja fechar mesmo assim?",
            callback: (ok) => {
                if (ok) {
                    if (props.onCloseEv)
                        props.onCloseEv();
                }
            }
        });
    }

    // NOVO: handleSelectAll só marca/desmarca os registros filtrados (como em gruposacl)
    const handleSelectAll = () => {
        if (!permissoes || !permissoesFiltradas) return;

        // Verifica se todos os filtrados estão marcados
        const allFilteredChecked = permissoesFiltradas.length > 0 && permissoesFiltradas.every(p => p.checked);

        // Mapeia todas as permissões, alterando checked apenas para as filtradas
        const nomesFiltrados = new Set(permissoesFiltradas.map(p => p.name));
        const _permissoes = permissoes.map(permissao => {
            if (nomesFiltrados.has(permissao.name)) {
                return { ...permissao, checked: !allFilteredChecked };
            }
            return permissao;
        });
        setPermissoes(_permissoes);
        // Não precisa de setSelectAll, pois o checked do checkbox é calculado dinamicamente
    };

    const handlePermissao = (permissao) => {
        let _permissoes = permissoes.map((_permissao) => ({
            ..._permissao,
            checked: _permissao.name === permissao.name ? !_permissao.checked : _permissao.checked
        }));

        setPermissoes(_permissoes);
        setClickedTr(permissao);
    }

    // Largura da coluna do checkbox (em px)
    const checkboxColWidth = 35;

    // CSS para colunas fixas
    const fixedColStyles = {
        position: "sticky",
        left: 0,
        background: "#fff",
        zIndex: 3,
        borderRight: "1px solid #dee2e6",
        borderBottom: "1px solid #dee2e6",
        borderTop: "1px solid #dee2e6",
        borderLeft: "1px solid #dee2e6",
        fontSize: "14px", // aumentada
        padding: "2px 6px",
        verticalAlign: "middle",
        width: checkboxColWidth
    };

    // As colunas de permissão e descrição devem ocupar 30% e 70% do espaço restante (100% - checkboxColWidth)
    // Usamos calc para garantir o desconto da largura do checkbox
    const permissaoColWidth = "calc(30% - 0px)"; // 30% do espaço restante
    const descricaoColWidth = "calc(70% - 0px)"; // 70% do espaço restante

    // Para sticky, precisamos calcular o left das colunas
    const fixedCol2Styles = {
        position: "sticky",
        left: checkboxColWidth,
        background: "#fff",
        zIndex: 3,
        borderRight: "1px solid #dee2e6",
        borderBottom: "1px solid #dee2e6",
        borderTop: "1px solid #dee2e6",
        fontSize: "14px", // aumentada
        padding: "2px 6px",
        verticalAlign: "middle",
        width: permissaoColWidth,
        minWidth: 0,
        maxWidth: "none",
        boxSizing: "border-box"
    };
    const fixedCol3Styles = {
        position: "sticky",
        left: `calc(${checkboxColWidth}px + ${permissaoColWidth})`,
        background: "#fff",
        zIndex: 2,
        borderBottom: "1px solid #dee2e6",
        borderTop: "1px solid #dee2e6",
        fontSize: "14px", // aumentada
        padding: "2px 6px",
        verticalAlign: "middle",
        width: descricaoColWidth,
        minWidth: 0,
        maxWidth: "none",
        boxSizing: "border-box"
    };

    // CSS para fixar o cabeçalho da tabela
    const theadStickyStyle = {
        position: "sticky",
        top: 0,
        zIndex: 4,
        background: "#fff",
        borderTop: "1px solid #dee2e6",
        borderBottom: "2px solid #dee2e6"
    };

    // CSS para th do cabeçalho (para garantir bordas)
    const thHeaderStyle = {
        border: "1px solid #dee2e6",
        background: "#fff",
        zIndex: 4,
        fontSize: "14px", // aumentada
        padding: "2px 6px",
        height: "28px", // voltou para 28
        verticalAlign: "middle"
    };

    // CSS para as células da tabela (td)
    const tdStyle = {
        fontSize: "14px", // aumentada
        padding: "2px 6px",
        height: "28px", // altura fixa da linha
        minHeight: "28px",
        maxHeight: "28px",
        verticalAlign: "middle"
    };

    // CSS para a div externa da tabela
    const outerTableDivStyle = {
        border: "0.5px solid #bdbdbd",
        margin: 0,
        padding: 0,
        width: "100%",
        background: "#dee2e6", // cinza bem clarinho, igual à cor da borda da tabela
        minHeight: 400,
        maxHeight: 400,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start"
    };

    // CSS para o rodapé do cabeçalho (abaixo do input de pesquisa)
    const headerFooterStyle = {
        borderBottom: "1px solid #dee2e6",
        marginBottom: 0,
        paddingBottom: 0
    };

    // CSS para o botão de limpar (X) do input de pesquisa
    const clearButtonStyle = {
        position: "absolute",
        right: 10,
        top: "50%",
        transform: "translateY(-50%)",
        background: "transparent",
        border: "none",
        cursor: "pointer",
        fontSize: "16px",
        color: "#888",
        padding: 0,
        zIndex: 10,
        lineHeight: 1
    };

    // --- NOVO: Cálculo dos totais para o rodapé da tabela ---
    const total = permissoesFiltradas ? permissoesFiltradas.length : 0;
    const marcadas = permissoesFiltradas ? permissoesFiltradas.filter(p => p.checked).length : 0;
    const desmarcadas = permissoesFiltradas ? permissoesFiltradas.filter(p => !p.checked).length : 0;

    // CSS para o rodapé fora da tabela, colunas alinhadas à esquerda
    const footerSummaryStyle = {
        display: "flex",
        width: "100%",
        background: "#f8f9fa",
        fontWeight: "bold",
        fontSize: "13px",
        borderTop: "2px solid #dee2e6",
        borderBottom: "1px solid #dee2e6",
        margin: 0,
        padding: 0,
        minHeight: "36px"
    };
    const footerSummaryColStyle = {
        flex: 1,
        textAlign: "left",
        padding: "8px 6px",
        borderRight: "1px solid #dee2e6",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start"
    };
    const footerSummaryColLastStyle = {
        ...footerSummaryColStyle,
        borderRight: "none"
    };

    // NOVO: estilos para o container do filtro e input
    const filterRowStyle = {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        gap: 0
    };
    const searchInputContainerStyle = {
        position: "relative",
        width: "85%"
    };
    // Ajuste: reduzir tamanho do container do checkbox "Marcadas" para o mínimo necessário e padding de 2px à esquerda
    const onlyCheckedContainerStyle = {
        minWidth: "auto",
        width: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        paddingLeft: 2
    };
    // Ajuste: reduzir tamanho da label para o mínimo necessário, padding à esquerda de 4px
    const onlyCheckedLabelStyle = {
        fontSize: "13px",
        marginLeft: 4,
        userSelect: "none",
        cursor: "pointer",
        whiteSpace: "nowrap",
        padding: 0
    };

    // Renderiza a tabela de permissões novamente
    return (
        <>
            <Modal
                size="lg"
                show={true}
                onHide={handleClose}
                centered
                animation={false}
                backdrop="static"
                dialogClassName={width() !== "mobile" ? "modal-90w" : ""}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span>Configuração de Permissões</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="maxWidth750" style={{ maxHeight: width() !== "mobile" ? "80vh" : "auto", overflowY: "auto" }}>
                    <div>
                        Usuário: <label><strong>{usuario?.nome || usuario?.name}</strong></label>
                    </div>
                    <div
                        style={{ backgroundColor: "rgba(231, 230, 230,  0.18)" }}
                    >
                        <div style={{ position: "sticky", top: 0, zIndex: 5, backgroundColor: "#fff", padding: "10px 0" }}>
                            <div style={filterRowStyle}>
                                <div style={searchInputContainerStyle}>
                                    <input
                                        ref={searchInputRef}
                                        type="text"
                                        placeholder="Pesquisar permissão"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        style={{
                                            width: "100%",
                                            padding: "8px 32px 8px 8px", // espaço para o X
                                            border: "1px solid #ddd",
                                            borderRadius: "4px"
                                        }}
                                        autoFocus
                                    />
                                    {searchTerm && (
                                        <button
                                            type="button"
                                            aria-label="Limpar pesquisa"
                                            style={clearButtonStyle}
                                            onClick={() => {
                                                setSearchTerm('');
                                                if (searchInputRef.current) {
                                                    searchInputRef.current.focus();
                                                }
                                            }}
                                            tabIndex={0}
                                        >
                                            &#10005;
                                        </button>
                                    )}
                                </div>
                                <div style={onlyCheckedContainerStyle}>
                                    <input
                                        type="checkbox"
                                        id="onlyCheckedAcls"
                                        checked={showOnlyChecked}
                                        onChange={e => setShowOnlyChecked(e.target.checked)}
                                        style={{ margin: 0 }}
                                    />
                                    <label
                                        htmlFor="onlyCheckedAcls"
                                        style={onlyCheckedLabelStyle}
                                        title="Exibir apenas permissões marcadas"
                                    >
                                        Marcadas
                                    </label>
                                </div>
                            </div>
                            <div style={headerFooterStyle}></div>
                        </div>
                        <div style={outerTableDivStyle}>
                            <div style={{
                                flex: 1,
                                overflowY: "auto",
                                margin: 0,
                                padding: 0
                            }}>
                                {carregando ? (
                                    <div style={{ textAlign: "center", padding: 20, fontSize: "14px" }}>Carregando permissões...</div>
                                ) : (
                                    <table className="table table-sm table-bordered"
                                        style={{
                                            background: "#fff",
                                            minWidth: 600,
                                            fontSize: "14px",
                                            margin: 0,
                                            tableLayout: "fixed",
                                            width: "100%"
                                        }}>
                                        <colgroup>
                                            <col style={{ width: checkboxColWidth }} />
                                            <col style={{ width: permissaoColWidth }} />
                                            <col style={{ width: descricaoColWidth }} />
                                        </colgroup>
                                        <thead style={theadStickyStyle}>
                                            <tr>
                                                <th style={{ ...thHeaderStyle, width: checkboxColWidth, ...fixedColStyles }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={permissoesFiltradas && permissoesFiltradas.length > 0 && permissoesFiltradas.every(p => p.checked)}
                                                        onChange={handleSelectAll}
                                                        title="Selecionar todas"
                                                        style={{ margin: 0 }}
                                                    />
                                                </th>
                                                <th style={{ ...thHeaderStyle, width: permissaoColWidth, ...fixedCol2Styles }}>Permissão</th>
                                                <th style={{ ...thHeaderStyle, width: descricaoColWidth, ...fixedCol3Styles }}>Descrição</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {permissoesFiltradas && permissoesFiltradas.length > 0 ? (
                                                permissoesFiltradas.map((permissao, idx) => (
                                                    <tr
                                                        key={permissao.name + idx}
                                                        style={{
                                                            background: clickedTr && clickedTr.name === permissao.name ? "#e6f7ff" : undefined,
                                                            cursor: "pointer",
                                                            height: "28px", // altura fixa da linha
                                                            minHeight: "28px",
                                                            maxHeight: "28px"
                                                        }}
                                                        onClick={() => handlePermissao(permissao)}
                                                    >
                                                        <td style={{ ...fixedColStyles, ...tdStyle }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={!!permissao.checked}
                                                                onChange={() => handlePermissao(permissao)}
                                                                onClick={e => e.stopPropagation()}
                                                                style={{ margin: 0 }}
                                                            />
                                                        </td>
                                                        <td style={{ ...fixedCol2Styles, ...tdStyle }}>{permissao.label || permissao.name}</td>
                                                        <td style={{ ...fixedCol3Styles, ...tdStyle }}>{permissao.description}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={3} style={{ textAlign: "center", fontSize: "14px", padding: "2px 6px", height: "28px", minHeight: "28px", maxHeight: "28px" }}>Nenhuma permissão encontrada</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                            {/* Rodapé fora da tabela, colunas alinhadas à esquerda */}
                            <div style={footerSummaryStyle}>
                                <div style={footerSummaryColStyle}>
                                    Quantidade: <span style={{ fontWeight: "normal", marginLeft: 4 }}>{total}</span>
                                </div>
                                <div style={footerSummaryColStyle}>
                                    Marcadas: <span style={{ fontWeight: "normal", marginLeft: 4 }}>{marcadas}</span>
                                </div>
                                <div style={footerSummaryColLastStyle}>
                                    Desmarcadas: <span style={{ fontWeight: "normal", marginLeft: 4 }}>{desmarcadas}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button color="success" onClick={handlePost} disabled={gravando} style={{ fontSize: "13px" }}>
                        Gravar
                    </Button>
                    <Button color="secondary" onClick={() => handleClose(false)} disabled={gravando} style={{ fontSize: "13px" }}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
};

function mapStateToProps(state) {
    return {
        user: state.dados.user,
    };
}

export default connect(mapStateToProps)(Form);
